<div class="ui-toggle" [class.ui-toggle--toggled]="toggled()" [class.ui-toggle--disabled]="disabled()" (click)="toggle()">
  <div class="ui-toggle__bar">
    <div class="ui-toggle__ball">
      <div class="ui-toggle__check"></div>
    </div>
  </div>
</div>
